import { render, staticRenderFns } from "./alt-checkbox-select.vue?vue&type=template&id=56c26c5d&scoped=true&"
import script from "./alt-checkbox-select.ts?vue&type=script&lang=ts&"
export * from "./alt-checkbox-select.ts?vue&type=script&lang=ts&"
import style0 from "./alt-checkbox-select.scss?vue&type=style&index=0&id=56c26c5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c26c5d",
  null
  
)

export default component.exports